import styled, { css } from 'styled-components';

export const Wrap = styled.div`
  background-color: #fff;
`;

export const Tab = styled.div`
  padding: 0px 30px 30px 30px;
  border-bottom: 1px solid #e3e3e3;
  > div {
    display: flex;
    height: 50px;
    border: 1px solid #78818e;
  }
`;

export const TabButton = styled.button`
  flex: 1;
  height: 100%;
  background-color: #78818e;
  color: #fff;
  font-size: 12px;
  ${(props) =>
    props.active &&
    css`
      background-color: #fff;
      color: #373f4c;
    `}
  :disabled {
    color: rgba(255, 255, 255, 0.3);
  }
`;

export const List = styled.ul``;

export const ListItem = styled.li`
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  :not(:last-child) {
    border-bottom: 1px solid rgb(236, 239, 243);
  }

  .no-data {
    font-size: 12px;
    color: #373f4c;
    font-weight: 500;
  }

  .score-container {
    display: flex;
    align-items: center;
    position: relative;
    > span {
      padding: 0 3px;
      font-family: Roboto, sans-serif;
      font-size: 16px;
      font-weight: 700;

      &.up {
        color: #ee1a21;
      }
    }
    &.home {
      .diff {
        left: -48px;
      }
    }
    &.away {
      .diff {
        left: 48px;
      }
    }

    .diff {
      position: absolute;
      left: -48px;
      padding: 0 6px;
      height: 20px;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      font-weight: 700;
      background: #fff;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.05);
      color: #1aa251;
      &.up {
        color: #1aa251;
      }

      &.down {
        color: #ee1a21;
      }
    }
  }

  .separator {
    padding: 0 4px;
    font-weight: 700;
    font-size: 16px;
  }

  ${(props) =>
    props.effect &&
    css`
      p {
        font-weight: 600;
      }
    `}
`;
